import { IDecisionActForm } from 'DecisionPackage/MainModule/interfaces/IDecisionActForm';

import styles from './DecisionActStatus.module.scss';

interface IDecisionActProps {
  act: IDecisionActForm | undefined;
}

export const DecisionActStatus = ({ act }: IDecisionActProps) => {
  if (act?.paperless && act.isNew) return <div className={styles.ActStatus}>Черновик</div>;

  if (act?.fileInvalidate) return <div className={styles.ActStatusCanceled}>Отменено</div>;

  return null;
};
